<template>
  <DxPopup @hidden="onHidden" :visible="makePop" :show-close-button="true" :show-title="true" :title="'ITP Information Request Final block'" :height= window.height  :width= window.width container=".v-application">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="'Information Request ITP'"
          :useBtnList="useBtnList"
          @btnRetrieve="btnRetrieve" @btnApplyRequest="btnApplyRequest" @btnClose="btnClose"
        >
          <template v-slot:body>
            <v-layout column >
              <v-row no-gutters>
                <v-col cols="12">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                  >
                    <template v-slot:body>
                      <v-row no-gutters class="center pa-0 pl-1">
                        <v-col cols="12">
                          <v-row dense>
                            <i-label :label="'Supplier name : '"/>
                            <v-col cols="3">
                              <v-select
                                v-model="supName"
                                :items="supNameList"
                                item-value="custCd"
                                item-text="supName"
                                return-object
                                single-line
                                outlined
                                dense
                              ></v-select>
                            </v-col>
                            <i-label :label="'Ship No : '"/>
                            <v-col cols="1">
                              <v-text-field
                                v-model="shipNo" 
                                dense 
                                outlined 
                                hide-details="auto"
                                height="32"
                                readonly
                              />
                            </v-col>
                            <i-label :label="'QM Part : '" class="pl-2"/>
                            <v-col cols="1" >
                              <v-select
                                v-model="qmPart"
                                :items="qmPartList"
                                item-value="code"
                                item-text="codeName"
                                return-object
                                single-line
                                outlined
                                dense
                                disabled
                              ></v-select>
                            </v-col>
                            <i-label :label="'Block Search : '" class="pl-2"/>
                            <v-col cols="1" >
                              <v-text-field
                                v-model="block" 
                                dense 
                                outlined 
                                hide-details="auto"
                                height="32"
                                maxlength='20'
                                @keydown="uppercase"
                              />
                            </v-col>
                          </v-row>
                          <v-row dense class="ma-0">
                            <i-label :label="'Inspection Kind : '"/>
                            <v-col cols="2" >
                              <v-select
                                v-model="inspKind"
                                :items="inspKindList"
                                item-value="code"
                                item-text="codeName"
                                return-object
                                single-line
                                outlined
                                dense
                                @change="doSearchMain()"
                              ></v-select>
                            </v-col>  
                            <i-label :label="'Insp. date/Time : '"  class="pl-2"/>
                            <v-col cols="1" class="pl-0">
                              <DxDateBox
                                :value="insDate"
                                height="30px"
                                display-format="yyyy-MM-dd"
                                :acceptCustomValue="false"
                                @value-changed="e => {reqDtFrom = e.value && getStrFormat(e.value)}"
                              />
                            </v-col>
                            <v-col cols="1">
                              <v-select
                                v-model="insTime"
                                :items="insTimeList"
                                item-value="codeName"
                                item-text="timeNm"
                                return-object
                                single-line
                                outlined
                                dense
                              ></v-select>
                            </v-col>
                            <i-label :label="'LQC member : '"  class="pl-2"/>
                            <v-col cols="1">
                              <v-select
                                v-model="empLqc"
                                :items="empLqcList"
                                item-value="empNo"
                                item-text="enm"
                                return-object
                                single-line
                                outlined
                                dense
                              ></v-select>
                            </v-col>
                            <i-label :label="'insp. Place : '"  class="pl-2"/>
                            <v-col cols="1">
                              <v-select
                                v-model="inspLoc"
                                :items="inspLocList"
                                item-value="code"
                                item-text="codeName"
                                return-object
                                single-line
                                outlined
                                dense
                              ></v-select>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="v80o1020MakePop"
                    :ref="v80o1020MakePopRef"
                    :height= window.heightDx
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="false"
                    :column-hiding-enabled="false"
                  >
                    <DxColumn data-field="no" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="shipNo" caption="Ship No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="block" caption="Block" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="kindCd" caption="Kind of Insp" width="10%" data-type="string" alignment="center" :allow-editing="true">
                      <DxLookup :data-source="inspKindList" display-expr="codeName" value-expr="code" />
                    </DxColumn>

                    <DxColumn data-field="inspAct" caption="Activity No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="itemDesc" caption="Inspection Items" width="20%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="remark" caption="Remark" width="32%" data-type="string" alignment="center" :allow-editing="true" />
                    <DxColumn data-field="inspStat" caption="Status" width="5%" data-type="string" alignment="center" :allow-editing="false"/>


                    <DxPaging :enabled="true" :page-size="18" />
                    <DxPager :visible="true"  :showInfo="false" />
                  </DxDataGrid>
                  <span style="font-weight: bold;">Count Total: {{ totalRow }} Row(s)</span>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { DxDataGrid, DxEditing, DxColumn , DxPager ,DxLookup } from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import { getAddList , v80a1040Save } from '@/api/view/hip/8/v80a1040Popup.js'
import { getDateFormat , getCurrentDate } from '@/utils/common.js'
import notify from 'devextreme/ui/notify' // message
import dayjs from 'dayjs'

export default {
  name: 'v80o1020MakePop',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup,
    ICardVertical,
    iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPager,
    DxDateBox,
    DxLookup
  },
  props: {
    makePop: {
      type: Boolean,
      default() { return false }
    },
    popupData: {
      type: Array,
      default() { return }
    },
    supNameListPop: {
      type: Array,
      default() { return }
    },
    insTimeListPop: {
      type: Array,
      default() { return }
    },
    qmPartListPop: {
      type: Array,
      default() { return }
    },
    inspLocListPop: {
      type: Array,
      default() { return }
    },
    inspKindListPop: {
      type: Array,
      default() { return }
    },
    empLqcListPop: {
      type: Array,
      default() { return }
    },
  },
  data() {
    return {
      useBtnList: ['btnRetrieve' , 'btnApplyRequest' , 'btnClose'],
      v80o1020MakePopRef: 'v80o1020MakePopRef',
      gridMainList: [],
      totalRow: 0,

      shipNo: '',
      block: '',
      inspLoc: null,

      qmPart: '',
      insDate: null,
      insTime: null,
      inspKind: this.inspKindListPop[0],

      custCd: null,
      supName: null,
      supNameList: this.supNameListPop,
      shipNoList: this.shipNoListPop,
      kindCdList: this.inspectionListPop,
      insTimeList: this.insTimeListPop,
      qmPartList: this.qmPartListPop,
      inspKindList: this.inspKindListPop,

      kindInspList: this.kindInspListPop,
      blockList:[],
      inspLocList: this.inspLocListPop,
      empLqcList: this.empLqcListPop,
      empLqc: this.empLqcListPop[1],

      window: {
        width: 0, height: 0, heightDx: 0
      }

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.v80o1020MakePopRef)
    },
  },
  watch: {
    'makePop': {
      handler(value, oldValue) {
        if(value) {
          
          this.shipNo = ''
          this.block = ''
          this.inspLoc = null

          this.qmPart = ''
          this.insDate = null
          this.insTime = null
          this.inspKind = this.inspKindListPop[0]

          this.custCd = null
          this.supName = null
          this.supNameList = this.supNameListPop
          this.shipNoList = this.shipNoListPop
          this.kindCdList = this.inspectionListPop
          this.insTimeList = this.insTimeListPop
          this.qmPartList = this.qmPartListPop
          this.inspKindList = this.inspKindListPop

          this.kindInspList = this.kindInspListPop
          this.blockList =[]
          this.inspLocList = this.inspLocListPop
          this.empLqcList = this.empLqcListPop
          this.empLqc = this.empLqcListPop[1]

          this.supName = this.popupData.supName
          this.qmPart = this.popupData.qmPart
          this.shipNo = this.popupData.shipNo
          this.insDate = this.popupData.stDate
          this.doSearchMain()

          window.addEventListener('resize', this.handleRezie)
          window.removeEventListener('resize', this.handleRezie)
          this.handleRezie()

        }
      },
      immediate: true
    }

  },
  mounted(){
    window.addEventListener('resize', this.handleRezie);
    this.handleRezie();
    // this.supName = this.popupData.supName
    // this.qmPart = this.popupData.qmPart
    // this.shipNo = this.popupData.shipNo
    // this.insDate = this.popupData.stDate
    // this.doSearchMain()
    this.gridMainInstance.option('defaultPaging', false)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleRezie);
  },
  methods: {

    handleRezie(){
      this.window.width    = window.innerWidth - 100;
      this.window.height   = window.innerHeight - 100;
      this.window.heightDx = window.innerHeight - 380;
    },

    getStrFormat(date) {
      this.insDate = date
      return getDateFormat(date)
    },
    onHidden(e) {
      this.$emit('update:makePop', false)
    },
    async doSearchMain(){
      this.gridMainList = []
      this.totalRow = 0

      let supNameGbn = this.supName
      supNameGbn = supNameGbn.split(' : ')

      let params = {
        custCd: supNameGbn[0],
        shipNo: this.shipNo,
        qmPart: this.qmPart.code,
        block: !this.block ? '' : this.block ,
        kindCd: this.inspKind.code
      }
      await getAddList(params).then(res => {
        if(res.list.length){
          let cnt = 1
          res.list.forEach(e => {
            e.id = cnt
            e.no = cnt++
          });
          this.gridMainList = res.list
          this.totalRow = res.list.length
        }
      })
    },
    btnRetrieve(e){
      if(!this.supName){
        this.vToastify(this.$t('There is no Supplier to retrieve.'), 'warn')
        return
      }
      //shipNo
      if(!this.shipNo){
        this.vToastify(this.$t('There is no Supplier to retrieve.'), 'warn')
        return
      }
      this.doSearchMain()
    },
    async btnApplyRequest(){
      await this.gridMainInstance.saveEditData()
      var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
      let minDate = new Date
      minDate.setDate(minDate.getDate() + 1);
      minDate = dayjs(minDate).format('YYYY-MM-DD')

      if(!this.empLqc.empNo){
        this.vToastify(this.$t('Please select LQC membert!'), 'warn')
        return
      }
      if(!this.inspLoc){
        this.vToastify(this.$t('Please select Inspection place!'), 'warn')
        return
      }

      if(!selectedMainRows.length){
        this.vToastify(this.$t('Data is not selected!.'), 'warn')
        return
      }

      let supNameGbn = this.supName
      supNameGbn = supNameGbn.split(' : ')

      for(var row of selectedMainRows){
        if(row.shipNo != this.shipNo){
          this.vToastify(this.$t('Ship No is different.'), 'warn')
          return
        }
        if(!this.insDate){
          this.vToastify(this.$t('Select Inspection Date.'), 'warn')
          return
        }
        if(!this.insTime){
          this.vToastify(this.$t('Select Inspection Time.'), 'warn')
          return
        }
        if(dayjs(this.insDate).format('YYYY-MM-DD') < minDate){
          this.vToastify(this.$t('You can not inspection request the inspection of this day. You select Inspection Date over today please!'), 'warn')
          return
        }

        let filter = []
        filter = this.supName.split(' : ')
        row.custCd = filter[0]
        row.porNo = !row.porNo ? '' : row.porNo
        row.porSeq = !row.porSeq ? '' : row.porSeq
        row.porQty = !row.porQty ? '' : row.porQty

        row.remark = !row.remark ? '' : row.remark
        row.insDate = dayjs(this.insDate).format('YYYY-MM-DD')
        row.insTime = this.insTime.codeName
        row.userId = this.$store.state.user.userId
        row.empNo = this.empLqc.empNo
        row.inspLoc = this.inspLoc.code
      }
      
      try{
        this.openLoading('searching')
        v80a1040Save(selectedMainRows).then(res => {
          if(res.body == 'Y'){
            notify(this.$t('Request Inspection saving is completed.'), 'success', 3000)
          }else {
            this.vToastify(this.$t('An error has been occured while saving data : ' + "<br>" + res.body), 'warn')
          }
        })
        .catch(error => {
          this.endLoading()
        })
        .finally(() => {
          this.gridMainInstance.clearSelection()
          this.doSearchMain()
        })
      } finally{
        this.endLoading()
      }
    },
    btnClose(){
      this.onHidden()
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '0px'
      }
    },
    uppercase(e){
      if(this.block){
        this.block = this.block.toUpperCase()
      }
      if(e.keyCode === 13){
        this.btnRetrieve()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn {
  background-color: rgb(135,155,119);
  margin-right: 2px;
  font-size: 10pt;
  color: white;
}
.btnClick{
  padding: 0;
  font-size: 12px;
}
.btnClick:hover{
  color: #4980BC;
}
.subText {
  font-size: 10pt;
  font-weight: bold;
  color: black;
}
</style>